import { render, staticRenderFns } from "./addVendorPayment.vue?vue&type=template&id=058af1a1"
import script from "./addVendorPayment.vue?vue&type=script&lang=js"
export * from "./addVendorPayment.vue?vue&type=script&lang=js"
import style0 from "./addVendorPayment.vue?vue&type=style&index=0&id=058af1a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports